package ru.it_mozaika.sender.js.application.components.subscribers

import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.components.SubscriptionListSelect
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import ru.it_mozaika.sender.js.application.context.SubscriptionListContext
import web.cssom.*

external interface SubscriptionDialogProps: Props {
    var subscribers: List<SubscriberData>
    var emailVerified: Boolean
    var onClose: () -> Unit
    var subscribe: Boolean?
    var isOpen: Boolean
    var requestHandler: () -> Unit
}

val subscriptionDialog = FC<SubscriptionDialogProps> { props ->
    val subscriptionContext = useContext(SubscriptionListContext)
    var inProcess by useState(false)
    val (subscribers, setSubscribers) = useState<List<SubscriberData>>(listOf())
    useEffect(props.subscribers) {
        setSubscribers(props.subscribers)
    }
    val currentStore = useContext(StoreContext).currentStore
    val backdrop = useContext(BackdropContext)
    val request = useMemo(props.subscribers, subscriptionContext.currentIds) {
        props.subscribers.map { subscriber ->
            SubscribeEmailRequest(
                confirmed = subscriber.emailVerified,
                email = subscriber.email,
                store = currentStore?.id,
                subscriptionLists = subscriptionContext.currentLists().map { it.id }
            )
        }
    }
    val respondContext = useContext(RequestResultContext)
    val ending = useMemo(subscribers.size) {
        when {
            subscribers.size == 1 -> "контакт"
            subscribers.size in 2..4 -> "контакта"
            else -> "контактов"
        }
    }

    fun subscribe() {
        backdrop.show()
        inProcess = true
        Http.post(
            "/subscribers/subscribe/list",
            body = request,
            query = mapOf("store" to currentStore?.id!!)
        ) { response ->
            respondContext.handleRequestRespond(response)
            backdrop.hide()
            inProcess = false
            props.onClose()

        }
    }

    fun unsubscribe() {
        backdrop.show()
        inProcess = true
        Http.post(
            "/subscribers/unsubscribe/list",
            body = request,
            query = mapOf("store" to currentStore?.id!!)
        ) { response ->
            respondContext.handleRequestRespond(response)
            backdrop.hide()
            inProcess = false
            props.onClose()
        }
    }
    Dialog {
        sx {
            width = 100.pct
            marginTop = 56.px
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center
        }
        asDynamic().maxWidth = "xl"
        this.open = props.isOpen
        DialogTitle {
            + if (props.subscribe == true) {
                if (!props.emailVerified) {
                    "Обратите внимание!! Будет отправлено писем с подтверждением - ${subscribers.size} !"
                } else {
                    "Обратите внимание!! Будет подписано адресов без отправки писем подтверждения -${subscribers.size} !"
                }
            } else {
                "Вы уверены что хотите отписать ${subscribers.size} $ending от данных рассылок?"
            }
        }
        DialogContent {
            if (inProcess) {
                CircularProgress {
                    color = CircularProgressColor.secondary
                }
            } else {
                Stack {
                    sx {
                        margin = 10.px
                    }
                    direction = responsive(StackDirection.row)
                    spacing = responsive(5)
                    SubscriptionListSelect ()
                }
            }
        }
        DialogActions {
            sx {
                alignItems = AlignItems.end
            }
            Stack {

                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    +if (props.subscribe == true) "Подписать" else "Отписать"
                    onClick = {
                        if (props.subscribe == true && currentStore != null) {
                            subscribe()
                        }
                        if (props.subscribe == false && currentStore != null) {
                            unsubscribe()
                        }
                    }
                }
                Button {
                    +"Отмена"
                    variant = ButtonVariant.outlined
                    color = ButtonColor.error
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}